import { FC, PropsWithChildren, Suspense } from 'react'
import { Loader } from './Loader'

export const LazyComponent: FC<PropsWithChildren<{}>> = ({ children }) => (
  <Suspense fallback={<Loader />}>{children}</Suspense>
)
